module.exports = __webpack_public_path__ + "img/event-slider-6.7f180124.jpg";